import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import styled from "styled-components"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"

import {
  fetchData,
  removeData,
  showToast,
  showPopup,
  hidePopup,
} from "../../store/action"

import { toggleDrawer } from "../../store/action"
import Storage from "../../util/Storage"
import config from "../../Config"
import { event } from "../../components/reactGA"
import { isUser } from "../../util/CheckUser"
import i18n from "../../i18n"
import Cookie from "../../util/Cookie"

const Container = styled.div`
  height: 100%;
  padding-left: 5px;
  text-align: left;
`

const Profile = styled.div`
  height: 170px;
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 130px;
  margin: 20px 0 10px 0;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  max-width: 300px;
`

const ImgBox = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
`

const Name = styled.span`
    font-family: montserratRegular
    color: #fff;
    margin-top: 15px;
    margin-bottom: 5px
    font-size: 14px;
`

const MenuItems = styled.div`
  overflow-y: hidden;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-bottom: 10px;
  max-width: 300px;
`

const Items = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 20px
    height: 30px;
    cursor:pointer;
`

const LinkText = styled.span`
  color: #f8f9f9;
  font-size: 14px;
  margin-left: 20px;
`

const MenuView = ({ toggleDrawer, history, data, theme }) => {
  //const user = Storage.get("user")

  const MenuOptions = [
    {
      path: { pathname: "/play/", state: { selectedIndex: 0 } },
      icon: <img src={theme.menuIcons.home} alt='home' />,
      text: "Home",
    },

    {
      path: "/play/my-bids",
      icon: <img src={theme.menuIcons.myBids} alt='My Bids' />,
      text: "My Bids",
    },
    {
      path: "/play/invite-and-earn",
      // icon: (
      //   <img
      //     src={`${config.MRBIDNWIN_S3_IMAGE_URL}/invite-and-earn.svg`}
      //     alt='Invite and Earn'
      //   />
      // ),
      icon: <img src={theme.menuIcons.inviteAndEarn} alt='Invite and Earn' />,
      text: "InviteEarn",
    },
    {
      path: "/play/contact-us",
      icon: <img src={theme.menuIcons.contactUs} alt='Contact us' />,
      text: "ContactUs",
    },
    {
      path: "/play/terms-and-conditions",
      // icon: <img src={`${config.MRBIDNWIN_S3_IMAGE_URL}/tnc.svg`} alt='tnc' />,
      icon: <img src={theme.menuIcons.tnc} alt='TNC' />,
      text: "TNC",
    },
  ]
  const user = isUser()
  console.log("User ", user)
  console.log("is empt user", !isEmpty(user))
  let profileUrl = get(
    data,
    "imageUrl",
    `${config.MRBIDNWIN_S3_IMAGE_URL}/user_avatar.svg`
  )
  let userName = get(data, "name", i18n.t("Welcome"))

  var menuLogin = 1
  let host = window.location.hostname
  let subDomain = host.split(".")[0]
  let TESTIMONIALS_FL = `${config.TESTIMONIALS_OP}`
  var mtnFlag = 0

  if (TESTIMONIALS_FL.includes(subDomain)) {
    mtnFlag = 1
  }

  if (!isUser()) {
    console.log("User ", user)
    //For op where WIFI not used
    let SUB = `${config.NON_WIFI_OP}`
    let SEND_TO_BILLING = `${config.NO_LOGIN_OP}`
    console.log("SUB : ", SUB)
    if (SUB.includes(subDomain)) {
      menuLogin = 0
    } else if (SEND_TO_BILLING.includes(subDomain)) {
      menuLogin = 0
    }
  }

  let subStatus = Cookie.get("SubscriberStatus")
  console.log(subDomain, " Home ", subStatus)

  let statusSelected = 3
  if (subDomain === "epu" && subStatus === "SUBSCRIBED") {
    statusSelected = 2
  }

  console.log("this props", history)
  console.log("menu view props", this.props)

  return (
    <Container>
      <Profile style={{ backgroundColor: theme.secondaryColor }}>
        <ImgBox className='flex-center'>
          {/* <img
            style={{
              width: 90,
              height: 90,
              borderRadius: "50%",
              backgroundColor: "#fff",
            }}
            src={profileUrl}
            alt='side-menu-user-profile'
            onClick={() => {
              toggleDrawer({ openDrawer: false })
              history.push({
                pathname: "/play/",
                state: { selectedIndex: statusSelected },
              })
            }}
          /> */}
          <div
            style={{
              width: 90,
              height: 90,
              borderRadius: "50%",
              backgroundColor: "#1c1d23",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
            // onClick={() => {
            //   toggleDrawer({ openDrawer: false })
            //   history.push({
            //     pathname: "/play/",
            //     state: { selectedIndex: statusSelected },
            //   })
            // }}
            onClick={() => {
              history.push("/play/my-account")
            }}
          >
            <img
              src={
                localStorage.getItem("userImage")
                  ? JSON.parse(localStorage.getItem("userImage"))
                  : `${
                      config.BIDNWIN_S3_IMAGE_URL_NEW_UI
                    }/side-menu-icons/user-profile.png`
              }
              alt='side-menu-user-profile'
              style={
                localStorage.getItem("userImage") && {
                  width: "90px",
                  height: "90px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }
              }
            />
          </div>
          <Name
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/play/my-account")
            }}
          >
            {userName}
          </Name>
        </ImgBox>
      </Profile>
      <MenuItems style={{ backgroundColor: theme.secondaryColor }}>
        {MenuOptions.map((el, index) => {
          console.log("E1 ", index)
          return !(
            (menuLogin === 0 && index === 3) ||
            (mtnFlag == 0 && index == 4)
          ) ? (
            <Items
              key={index}
              onClick={() => {
                toggleDrawer({ openDrawer: false })
                history.push(el.path)
                event({
                  category: "Side Menu",
                  action: el.text,
                })
              }}
            >
              {el.icon}
              <LinkText className='montserratRegular'>
                {i18n.t(el.text.trim().replace(/\s/g, ""))}
              </LinkText>
            </Items>
          ) : (
            ""
          )
        })}

        {// false && !isEmpty(user) && (
        user && (
          <Items
            onClick={() => {
              Storage.clearAll()
              window.location.href = `${config.NETWORK_URL}` + "/logout"
              toggleDrawer({ openDrawer: false })
              event({
                category: "Side Menu",
                action: "Logout",
              })
              //window.location.reload()
            }}
          >
            <img
              src={`${
                config.BIDNWIN_S3_IMAGE_URL_NEW_UI
              }/side-menu-icons/logout.png`}
              alt='logout'
            />
            <LinkText className='montserratRegular'>
              {i18n.t("Logout")}
            </LinkText>
          </Items>
        )}
      </MenuItems>
    </Container>
  )
}

export default withRouter(
  connect(
    (state, ownProps) => {
      return {
        data: get(state, "data.homeData.userProfile"),
        theme: state.theme,
      }
    },
    { toggleDrawer, fetchData }
  )(MenuView)
)



// WEBPACK FOOTER //
// ./src/views/SideMenu/MenuView.js